import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import { DateTime } from 'luxon'
import { observer } from 'mobx-react-lite'
import { useContext, useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { RootStoresContext } from 'src'
import Footer from 'src/commponents/Footer'
import Header from 'src/commponents/Header'
import Loading from 'src/commponents/Loading'
import { BuildingWrapper, Wrapper } from 'src/commponents/Wrapper'
import { RouterPaths } from './RouterPaths'

interface IElementWrapper {
  isBackgroundImage: boolean
  isAuthScreen?: boolean
}

export const ElementWrapper = ({ isBackgroundImage, isAuthScreen = false }: IElementWrapper) => {
  return (
    <Wrapper isBackgroundImage={isBackgroundImage}>
      <BuildingWrapper
        container
        direction="column"
        justifyContent="space-between"
        wrap="nowrap"
        isBackgroundImage={isBackgroundImage}
      >
        <Grid item>
          <Box mb={5}>
            <Header />
          </Box>
        </Grid>

        <Grid item>
          <Outlet />
        </Grid>

        <Grid item>
          <Box mt={5}>
            <Footer isAuthScreen={isAuthScreen} />
          </Box>
        </Grid>
      </BuildingWrapper>
    </Wrapper>
  )
}

export const Auth = observer(() => {
  const location = useLocation()
  const RootStore = useContext(RootStoresContext)
  const { AuthStore } = RootStore

  if (AuthStore.isLoading) return <Loading />
  if (AuthStore.isTemporaryRegistration) return <Navigate replace to={RouterPaths.RegisterPassword} />
  if (AuthStore.shouldRegisterEmail) return <Navigate replace to={RouterPaths.EmailRegistration} />
  if (!AuthStore.isLoggedIn) return <Navigate replace to={`${RouterPaths.Login}?ref=${location.pathname}`} />

  return <ElementWrapper isBackgroundImage isAuthScreen />
})

export const ListenLocation = () => {
  const location = useLocation()
  const RootStore = useContext(RootStoresContext)
  const { ConfigurationStore } = RootStore

  const [checkDate, setCheckDate] = useState(DateTime.now().minus({ hours: 2 }))
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (DateTime.now().diff(checkDate, 'hours').hours < 1) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setCheckDate(DateTime.now())

    ConfigurationStore.get()
      .then(() => {
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }, [location.pathname])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  if (isLoading) return <Loading />

  if (location.pathname !== RouterPaths.Maintenance && ConfigurationStore.configurations.isMaintenanceMode)
    return <Navigate replace to={RouterPaths.Maintenance} />

  return <Outlet />
}
